import { graphql } from 'gql';

export const priceListUerFlattened = graphql(`
    query uerPriceListUer(
        $contractId: Long!
        $skip: Int
        $take: Int
        $where: PriceListUerRowDataFilterInput
        $order: [PriceListUerRowDataSortInput!]
    ) {
        uerPriceListUer(contractId: $contractId, skip: $skip, take: $take, order: $order, where: $where) {
            items {
                version
                id
                sectionName
                groupFullName
                unit
                code
                chapter
                uerClassifier
                name
                status
                currentPrices {
                    constructionTypeId
                    constructionTypeRelationStatus
                    unitCostWithOther
                    emm
                    ozp
                    pir
                    mtr
                    nr
                    sp
                    eqp
                    trn
                    zpm
                }
                isIncludedInWorkOrder
                isIncludedInAct
                isIncludedInWorkOrderChange
                justification
                workKind {
                    workCode
                    workInSum
                    workName
                    workRatio
                    workUniqueId
                    workUnit
                }
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const priceListUerSectionNameFilter = graphql(`
    query uerPriceListUerSectionNameFilter($contractId: Long!, $where: FilterValueOfStringFilterInput) {
        uerPriceListUerSectionNameFilter(contractId: $contractId, where: $where, take: 1000) {
            items {
                value
            }
        }
    }
`);

export const priceListUerGroupFullNameFilter = graphql(`
    query uerPriceListUerGroupFullNameFilter($contractId: Long!, $where: FilterValueOfStringFilterInput) {
        uerPriceListUerGroupFullNameFilter(contractId: $contractId, where: $where, take: 1000) {
            items {
                value
            }
        }
    }
`);

export const uerPriceListUerGroupDataFilterGql = graphql(`
    query uerPriceListUerGroupDataFilter($contractId: Long!, $where: FilterValueOfStringAndStringFilterInput) {
        uerPriceListUerGroupDataFilter(contractId: $contractId, where: $where, order: { value: ASC }) {
            items {
                id
                code
                value
            }
        }
    }
`);

export const priceListUerCodeFilter = graphql(`
    query uerPriceListUerCodeFilter($contractId: Long!, $where: FilterValueOfStringFilterInput) {
        uerPriceListUerCodeFilter(contractId: $contractId, take: 1000, where: $where) {
            items {
                value
            }
        }
    }
`);

export const priceListUerNameFilter = graphql(`
    query uerPriceListUerNameFilter($contractId: Long!, $where: FilterValueOfStringFilterInput) {
        uerPriceListUerNameFilter(contractId: $contractId, where: $where, take: 1000) {
            items {
                value
            }
        }
    }
`);

export const priceListUerChapterFilter = graphql(`
    query uerPriceListUerChapterFilter($contractId: Long!) {
        uerPriceListUerChapterFilter(contractId: $contractId, take: 1000) {
            items {
                value
            }
        }
    }
`);

export const priceListUerTypeFilter = graphql(`
    query uerPriceListUerTypeFilter($contractId: Long!) {
        uerPriceListUerTypeFilter(contractId: $contractId, take: 1000) {
            items {
                value
            }
        }
    }
`);

export const priceListUerStatusFilter = graphql(`
    query uerPriceListUerStatusFilter($contractId: Long!) {
        uerPriceListUerStatusFilter(contractId: $contractId, take: 1000) {
            items {
                value
            }
        }
    }
`);

export const priceListUerJustificationFilter = graphql(`
    query uerPriceListUerJustificationFilter($contractId: Long!, $where: FilterValueOfStringFilterInput) {
        uerPriceListUerJustificationFilter(contractId: $contractId, where: $where, take: 1000) {
            items {
                value
            }
        }
    }
`);

export const priceListUerWorkNameFilter = graphql(`
    query uerPriceListUerWorkNameFilter(
        $contractId: Long!
        $where: FilterValueOfStringFilterInput
        $order: [FilterValueOfStringSortInput!]
    ) {
        uerPriceListUerWorkNameFilter(contractId: $contractId, where: $where, take: 1000, order: $order) {
            items {
                value
            }
        }
    }
`);

export const priceListUerWorkInSumFilter = graphql(`
    query uerPriceListUerWorkInSumFilter($contractId: Long!, $where: FilterValueOfWorkInSumEnumFilterInput) {
        uerPriceListUerWorkInSumFilter(contractId: $contractId, where: $where, take: 1000) {
            items {
                value
            }
        }
    }
`);

export const uploadPriceListUerMutation = graphql(`
    mutation uerImportPriceListCollection($contractId: Long!, $fileContent: FileInput!) {
        uerImportPriceListCollection(contractId: $contractId, fileContent: $fileContent) {
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const priceListUerRemoveUnusedRows = graphql(`
    mutation uerRemoveUnusedUerRows($contractId: Long!) {
        uerRemoveUnusedUerRows(contractId: $contractId) {
            data {
                count
            }
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const uerRowReadyInfo = graphql(`
    query uerUerRowReadyInfo($contractId: Long!) {
        uerUerRowReadyInfo(contractId: $contractId) {
            data {
                contractId
                isPriceCollectionLoaded
                unreadyUerRowCount
            }
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const uerPriceListUerRow = graphql(`
    query uerPriceListUerRow($uerBaseRowId: Long!) {
        uerPriceListUerRow(uerBaseRowId: $uerBaseRowId) {
            data {
                code
                workScopes {
                    description
                    number
                }
            }
        }
    }
`);
